import FundingSource from './funding-source';
import FundingPayment from './funding-source';

export default FundingSource;

export {
    FundingSource,
    FundingPayment
};
